import React from "react";
import { Route } from "react-router-dom";

import Page from "@ROM-pages/CompanyAdmin/Users/Index";
import Layout from "@ROM-pages/Layouts/CompanyAdmin";
import Authorize from "@ROM/Auth/components/Authorize";
import { canAccessUsersInCompanyAdmin } from "@ROM/Users/permissions";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Authorize permission={canAccessUsersInCompanyAdmin}>
          <Page />
        </Authorize>
      </Layout>
    );
  }
}

export default RouteHandler;
